export const MAX_IDENTITY_DOCUMENT_BYTES = 25 * 1024 * 1024;
export const IDENTITY_DOCUMENT_ACCEPT = "image/jpeg,image/png,image/webp,application/pdf";
export const INVALID_IDENTITY_DOCUMENT_MESSAGE = "Choose a JPEG, PNG, WebP or PDF file, up to 25 MB. The file must not be empty.";

export function identityDocumentFileError(file: Blob): string | null {
  return !IDENTITY_DOCUMENT_ACCEPT.split(",").includes(file.type) || !file.size || file.size > MAX_IDENTITY_DOCUMENT_BYTES
    ? INVALID_IDENTITY_DOCUMENT_MESSAGE
    : null;
}
